/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { TodoListBusinessService } from '../../../resources/todo-list-business.service';

import { MutateTodoDialogComponent } from './mutate-todo-dialog.component';

export const mutateTodoDialog = createDialogRoute({
  component: MutateTodoDialogComponent,
  init: TodoListBusinessService,
});
